(async () => {
  const plyrs = Array.from(document.querySelectorAll('.js-plyr-iframe'));
  const plyrInterval = setInterval(() => {
    if (typeof Plyr === 'undefined') {
      return;
    }
    for (const plyr of plyrs) {
      if (!plyr.src) {
        continue;
      }
      initPlyr(new Plyr(plyr.parentNode, { clickToPlay: true, fullscreen: { iosNative: true } }), plyr.parentNode);
    }
    clearInterval(plyrInterval);
  }, 500);

  function initPlyr(player, parent) {
    if (player && parent) {
      // Once Plyr has the actual video dimensions from the provider (Vimeo/YouTube),
      // set the correct aspect-ratio on the embed container so the slide's flexbox
      // centering contains the video rather than cropping it.
      player.on('ready', function () {
        setTimeout(function () {
          var ratio = player.ratio;
          if (ratio) {
            var parts = ratio.split(':');
            parent.style.aspectRatio = parts[0] + '/' + parts[1];
          }
        }, 200);
      });

      parent.addEventListener('click', () => {
        if (window.innerWidth < 1000) {
          if (player.playing) {
            player.pause();
          } else {
            player.play();
          }
        }
      });
      player.on('play', () => {
        parent.querySelector('.plyr__poster').style.zIndex = -1;
        parent.querySelector('.plyr__poster').style.opacity = 0;
        parent.querySelector('.plyr__poster').style.display = 'none';
      });
      player.on('pause', () => {
        parent.querySelector('.plyr__poster').style.zIndex = 2;
        parent.querySelector('.plyr__poster').style.opacity = 1;
        parent.querySelector('.plyr__poster').style.display = 'block';
      });
      player.on('stop', () => {
        parent.querySelector('.plyr__poster').style.zIndex = 2;
        parent.querySelector('.plyr__poster').style.opacity = 1;
        parent.querySelector('.plyr__poster').style.display = 'block';
      });
    }
  }

  window.initPlyr = initPlyr;
})();
